import React from 'react';
import ReactDOM from 'react-dom';

import './App.css';
import Landing  from './components/landing'
import NotFoundComponent from './components/notfoundcomponent'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <Router>
    <div>
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route component={NotFoundComponent} />
    </Switch>
    </div>
  </Router>
  );
}

ReactDOM.render(<App/>,
  document.getElementById('root')
);

export default App;
